<template>
    <div>
        <div style="padding: 50px 0 0;display: flex;flex-direction: column;align-items: center;">
            <img style="height: 500px;display: block;" src="../../assets/03-hyCase/01.jpg" alt="">
            <!-- <div>
                <div style="display: flex; width: 100%; justify-content: center;margin-bottom: 10px;font-size: 24px;">
                    <div style="margin-right: 40px;">SiNCE</div>
                    <div>2008</div>
                </div>
                <div style="font-size: 24px;">汇柏软件已为以下政府部门和企业提供了优质的软件产品和定制化开发服务</div>
            </div> -->
            <img style="width: 100%;" src="../../assets/03-hyCase/02.png" alt="">
            <img style="height: 900px;width: 100%;" src="../../assets/03-hyCase/03.png" alt="">
        </div>
        <foot></foot>
    </div>
</template>
<script>
const axios = require('axios');
import foot from '../../components/foot'
export default {
    data:function(){
        return {

        }
    },
    methods:{
        
    },
    mounted(){
        
    },
    components:{ foot},
}
</script>
<style lang="less" >

</style>















// WEBPACK FOOTER //
// src/views/new/newslist.vue